import { activitiesConstants } from "@data/constants/activitiesConstants"

const initialState = {
    activityPaused: false,
    ongoingActivity: false,
    cameraOn: false,
    cameraReusesLiveTrack: false,
    audioStatus: "",
    updatedActivityEventData: null,
    timers: {}, // { [activityId]: { time, seenLottie } }
}

export default function activity(state = initialState, action) {
    switch (action.type) {
        case activitiesConstants.UPDATE_ACTIVITY_CHRONO:
            return {
                ...state,
                updatedActivityEventData: action?.data,
            }
        case activitiesConstants.AUDIO_STATUS:
            return {
                ...state,
                audioStatus: action?.data,
            }
        case activitiesConstants.ONGOING_ACTIVITY:
            return {
                ...state,
                ongoingActivity: action?.data,
            }
        case activitiesConstants.PAUSE_ACTIVITY:
            return {
                ...state,
                activityPaused: action?.data,
            }
        case activitiesConstants.SET_CAMERA_STATUS:
            return {
                ...state,
                cameraOn: action?.cameraOn,
                cameraReusesLiveTrack: action?.reusesLiveTrack ?? false,
            }
        case activitiesConstants.SET_TIMER_STATE: {
            const { activityId, time, seenLottie } = action.payload
            return {
                ...state,
                timers: {
                    ...state.timers,
                    [activityId]: {
                        ...(state.timers[activityId] || {}),
                        time,
                        seenLottie,
                    },
                },
            }
        }
        default:
            return state
    }
}
